/** Cache TTL constants in milliseconds */
export const CACHE_TTL = {
  conversations: 60 * 1000,    // 60s
  workflows: 2 * 60 * 1000,    // 2min
  instances: 5 * 60 * 1000,    // 5min
  activeInstance: 5 * 60 * 1000, // 5min
} as const;

/** Returns true if the data was fetched within the TTL window */
export function isCacheFresh(lastFetchedAt: number | null, ttl: number): boolean {
  if (lastFetchedAt === null) return false;
  return Date.now() - lastFetchedAt < ttl;
}

/**
 * Stale-while-revalidate fetch orchestration.
 *
 * - Fresh cache (within TTL): skip fetch entirely
 * - Stale cache with existing data: return immediately, refresh in background
 * - No data (first load): await the fetch
 * - options.force: bypass cache check
 */
export function fetchWithCache(
  hasData: boolean,
  lastFetchedAt: number | null,
  ttl: number,
  fetchFn: () => Promise<void>,
  options?: { force?: boolean },
): void {
  if (!options?.force && isCacheFresh(lastFetchedAt, ttl)) {
    return; // Fresh cache, nothing to do
  }

  if (hasData && !options?.force) {
    // Stale cache with data — background refresh (fire-and-forget)
    fetchFn().catch(() => {});
  } else {
    // No cached data or forced — await the fetch
    fetchFn().catch(() => {});
  }
}
